import Alert from './components/alert';
import Autocomplete from './components/autocomplete';
import Avatar from './components/avatar';
import Button from './components/button';
import ButtonGroup from './components/button-group';
import Chip from './components/chip';
import Container from './components/container';
import { default as BaselineTheme } from './components/css-baseline';
import DataGrid from './components/data-grid';
import Dialog from './components/dialog';
import Divider from './components/divider';
import Draggable from './components/Draggable';
import Forms from './components/forms';
import IconButton from './components/icon-button';
import Label from './components/label';
import Menu from './components/menu';
import Pagination from './components/pagination';
import Progress from './components/progress';
import Select from './components/select';
import Snackbar from './components/snackbar';
import Step from './components/step';
import Stepper from './components/stepper';
import Switch from './components/switch';
import Tab from './components/tab';
import TablePagination from './components/table-pagination';
import Text from './components/text';
import TextField from './components/text-field';
import Tooltip from './components/tooltip';
import { BORDER_RADIUS } from './constants';
import paletteTheme, { ColorPalette } from './palette';
import shadowsTheme from './shadows';
import {
  type BaseTheme,
  type PartialTheme,
  CssBaseline,
  ThemeProvider,
  createTheme,
  styled,
  useTheme,
  alpha,
} from './theme';
import typographyTheme, { typography } from './typography';
import { calculateBorderRadius } from './utils';
import './breakpoints';

const theme = createTheme({
  palette: paletteTheme,
  typography: typographyTheme,
  spacing: 4,
  components: {
    ...BaselineTheme,
    ...Button,
    ...IconButton,
    ...Label,
    ...Avatar,
    ...Chip,
    ...Tab,
    ...Tooltip,
    ...TablePagination,
    ...DataGrid,
    ...Dialog,
    ...Draggable,
    ...Forms,
    ...Text,
    ...TextField,
    ...Snackbar,
    ...Step,
    ...Stepper,
    ...Switch,
    ...Alert,
    ...Select,
    ...Autocomplete,
    ...Container,
    ...Menu,
    ...Progress,
    ...Pagination,
    ...ButtonGroup,
    ...Divider,
  },
  shadows: shadowsTheme,
  shape: {
    borderRadius: BORDER_RADIUS,
    rounded: calculateBorderRadius,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,

      // Custom breakpoints
      mobile: 0,
      tablet: 768,
      desktop: 1024,
    },
  },
});

export type { BaseTheme as Theme, PartialTheme };
export {
  CssBaseline,
  ThemeProvider,
  ColorPalette,
  createTheme,
  theme,
  typography,
  styled,
  useTheme,
  alpha,
};
